import React from 'react';
import styles from './Card.module.css';

type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  dark?: boolean;
};

const Card: React.FC<CardProps> = ({ dark = false, className, children, ...rest }) => (
  <div
    className={[styles.card, dark ? styles.dark : '', className || '']
      .filter(Boolean)
      .join(' ')}
    {...rest}
  >
    {children}
  </div>
);

export { styles as cardStyles };
export default Card;
